import { render, staticRenderFns } from "./Animal.vue?vue&type=template&id=a7131d50&scoped=true&"
import script from "./Animal.vue?vue&type=script&lang=js&"
export * from "./Animal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7131d50",
  null
  
)

export default component.exports